import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerFormComponent } from './customer/customer-form.component';
import { HomeComponent } from './home/home.component';
import { PetFormComponent } from './pet/pet-form/pet-form.component';
import { PetDetailComponent } from './pet/pet-detail/pet-detail.component';
import { CustomerAdressListComponent } from './customer-adress-list/customer-adress-list.component';
import { CustomerAdressFormComponent } from './customer-adress-form/customer-adress-form.component';
import { OrdersListComponent } from './orders-list/orders-list.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { SuccessComponent } from './shared/success/success.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { PantallaPendienteComponent } from './shared/pantalla-pendiente/pantalla-pendiente.component';
import { MisMascotasComponent } from './mascotas/mis-mascotas.component';
import { MisBeneficiosComponent } from './beneficios/mis-beneficios.component';
import { PreferenciasComponent } from './preferencias/preferencias.component';
import { HistorialPuntosComponent } from './puntos/historial-puntos.component';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';



const routes: Routes = [

  //{ path: 'login', component: LoginComponent },

  { path: 'home', component: HomeComponent},
  { path: 'success', component: SuccessComponent ,  canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'pet/:pet_id', component: PetDetailComponent,  canActivate: [AutoLoginPartialRoutesGuard]  },
  { path: 'add-pet', component: PetFormComponent ,  canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'edit-pet/:pet_id', component: PetFormComponent,  canActivate: [AutoLoginPartialRoutesGuard]  },

  { path: 'orders-list', component: OrdersListComponent ,  canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'edit-customer', component: CustomerFormComponent,  canActivate: [AutoLoginPartialRoutesGuard]  },
  { path: 'customer-adress-list', component: CustomerAdressListComponent ,  canActivate: [AutoLoginPartialRoutesGuard] },

  { path: 'add-customer-adress/:id', component: CustomerAdressFormComponent,  canActivate: [AutoLoginPartialRoutesGuard]  },
  { path: 'edit-customer-adress/:ix', component: CustomerAdressFormComponent,  canActivate: [AutoLoginPartialRoutesGuard]  },

  { path: 'order', component: OrderDetailComponent,  canActivate: [AutoLoginPartialRoutesGuard]  },
  { path: 'order/:id', component: OrderDetailComponent,  canActivate: [AutoLoginPartialRoutesGuard]  },

  { path: 'unauthorized', component: UnauthorizedComponent },

  // Pantallas del prototipo de Mi Cuenta. Las que todavia no estan construidas
  // van a un placeholder, para que el menu no tenga items muertos.
  { path: 'mis-mascotas',     component: MisMascotasComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'mis-beneficios',   component: MisBeneficiosComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'historial-puntos', component: HistorialPuntosComponent, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'preferencias',     component: PreferenciasComponent, canActivate: [AutoLoginPartialRoutesGuard] },


  {path: '', pathMatch: 'full', redirectTo: 'home'},
  {path: '**', pathMatch: 'full', redirectTo: 'home'}
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
